import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FileRecord } from '../models/ui/file.model';
import { FileSdk } from '../sdks/file.sdk';

/**
 * File related management operations
 */
@Injectable({
	providedIn: 'root'
})
export class FileManager {

	constructor(private fileSdk: FileSdk) {
	}

	public getSharedFileDetails(sharedId: string): Observable<FileRecord> {
		return this.fileSdk.getFileDetails({ sharedId });
	}

	public getSharedFileUrl(sharedId: string): Observable<string> {
		return this.fileSdk.download({sharedId});
	}
}
